module.exports = __webpack_public_path__ + "img/collection_food.8008bbcb.png";